import React, { Component } from "react";

import beerImage from "../../../services/images/drinks/beer.jpg";
import liquorImage from "../../../services/images/drinks/liquor.jpg";
import wineImage from "../../../services/images/drinks/wine.jpg";

import beerList from "../../../services/drinkLists/beerList";
import liquorList from "../../../services/drinkLists/liquorList";
import wineList from "../../../services/drinkLists/wineList";

class MenuModals extends Component {
  render() {
    return (
      <div>
        <section id="menu" className="bg-light-gray">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center">
                <h2 className="section-heading">Drink Menu</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-sm-6 portfolio-item">
                <a
                  href="#menuBeer"
                  className="portfolio-link"
                  data-toggle="modal"
                  onClick={() => {
                    document
                      .getElementById("page-top")
                      .classList.add("modal-open");
                    document.getElementById("menuBeer").style.display = "block";
                    document.getElementById("menuBeer").style.overflowX =
                      "hidden";
                    document.getElementById("menuBeer").style.overflowY =
                      "auto";
                    setTimeout(function () {
                      document.getElementById("menuBeer").classList.add("in");
                    }, 100);
                  }}
                >
                  <div className="portfolio-hover">
                    <div className="portfolio-hover-content">
                      <i className="fa fa-plus fa-3x" />
                    </div>
                  </div>
                  <img className="img-responsive" alt="" src={beerImage} />
                </a>
                <div className="portfolio-caption">
                  <h4>Beers</h4>
                  <p className="text-muted">39</p>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 portfolio-item">
                <a
                  href="#menuLiquor"
                  className="portfolio-link"
                  data-toggle="modal"
                  onClick={() => {
                    document
                      .getElementById("page-top")
                      .classList.add("modal-open");
                    document.getElementById("menuLiquor").style.display =
                      "block";
                    document.getElementById("menuLiquor").style.overflowX =
                      "hidden";
                    document.getElementById("menuLiquor").style.overflowY =
                      "auto";
                    setTimeout(function () {
                      document.getElementById("menuLiquor").classList.add("in");
                    }, 100);
                  }}
                >
                  <div className="portfolio-hover">
                    <div className="portfolio-hover-content">
                      <i className="fa fa-plus fa-3x" />
                    </div>
                  </div>
                  <img className="img-responsive" alt="" src={liquorImage} />
                </a>
                <div className="portfolio-caption">
                  <h4>Liquors</h4>
                  <p className="text-muted">74</p>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 portfolio-item">
                <a
                  href="#menuWine"
                  className="portfolio-link"
                  data-toggle="modal"
                  onClick={() => {
                    document
                      .getElementById("page-top")
                      .classList.add("modal-open");
                    document.getElementById("menuWine").style.display = "block";
                    document.getElementById("menuWine").style.overflowX =
                      "hidden";
                    document.getElementById("menuWine").style.overflowY =
                      "auto";
                    setTimeout(function () {
                      document.getElementById("menuWine").classList.add("in");
                    }, 100);
                  }}
                >
                  <div className="portfolio-hover">
                    <div className="portfolio-hover-content">
                      <i className="fa fa-plus fa-3x" />
                    </div>
                  </div>
                  <img className="img-responsive" alt="" src={wineImage} />
                </a>
                <div className="portfolio-caption">
                  <h4>Wines</h4>
                  <p className="text-muted">7</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Modals */}
        <div
          className="portfolio-modal modal fade"
          id="menuBeer"
          role="dialog"
          aria-hidden="true"
          style={{ background: "white" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div
                className="close-modal"
                data-dismiss="modal"
                onClick={() => {
                  document
                    .getElementById("page-top")
                    .classList.remove("modal-open");
                  document.getElementById("menuBeer").classList.remove("in");
                  setTimeout(function () {
                    document.getElementById("menuBeer").style.display = "none";
                  }, 400);
                }}
              >
                <div className="lr">
                  <div className="rl" />
                </div>
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-lg-8 col-lg-offset-2">
                    <div className="modal-body">
                      <h2>Beers</h2>
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                <strong>Draft Beers</strong>
                              </td>
                            </tr>
                            {beerList[0].list.map((beerDraft, index) => (
                              <tr key={index}>
                                <td>{beerDraft.name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <p
                        className="item-intro text-muted"
                        style={{
                          marginBottom: "10px;",
                        }}
                      />
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                <strong>Bottle Beers</strong>
                              </td>
                            </tr>
                            {beerList[1].list.map((beerBottled, index) => (
                              <tr key={index}>
                                <td>{beerBottled.name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-dismiss="modal"
                        onClick={() => {
                          document
                            .getElementById("page-top")
                            .classList.remove("modal-open");
                          document
                            .getElementById("menuBeer")
                            .classList.remove("in");
                          setTimeout(function () {
                            document.getElementById("menuBeer").style.display =
                              "none";
                          }, 400);
                        }}
                      >
                        <i className="fa fa-times"> Close</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Liquor Menu */}
        <div
          className="portfolio-modal modal fade"
          id="menuLiquor"
          role="dialog"
          aria-hidden="true"
          style={{ background: "white" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div
                className="close-modal"
                data-dismiss="modal"
                onClick={() => {
                  document
                    .getElementById("page-top")
                    .classList.remove("modal-open");
                  document.getElementById("menuLiquor").classList.remove("in");
                  setTimeout(function () {
                    document.getElementById("menuLiquor").style.display =
                      "none";
                  }, 400);
                }}
              >
                <div className="lr">
                  <div className="rl" />
                </div>
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-lg-8 col-lg-offset-2">
                    <div className="modal-body">
                      <h2>Liquors</h2>
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                <strong>Vodka</strong>
                              </td>
                            </tr>
                            {liquorList[0].list.map((liquorVodka, index) => (
                              <tr key={index}>
                                <td>{liquorVodka.name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <p
                        className="item-intro text-muted"
                        style={{
                          marginBottom: "10px;",
                        }}
                      />
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                <strong> Bourbon / Whiskey</strong>
                              </td>
                            </tr>
                            {liquorList[1].list.map((liquorBourbon, index) => (
                              <tr key={index}>
                                <td>{liquorBourbon.name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <p
                        className="item-intro text-muted"
                        style={{
                          marginBottom: "10px;",
                        }}
                      />
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                <strong>Gin</strong>
                              </td>
                            </tr>
                            {liquorList[2].list.map((liquorGin, index) => (
                              <tr key={index}>
                                <td>{liquorGin.name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <p
                        className="item-intro text-muted"
                        style={{
                          marginBottom: "10px;",
                        }}
                      />
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                <strong>Rum</strong>
                              </td>
                            </tr>
                            {liquorList[3].list.map((liquorRum, index) => (
                              <tr key={index}>
                                <td>{liquorRum.name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <p
                        className="item-intro text-muted"
                        style={{
                          marginBottom: "10px;",
                        }}
                      />
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                <strong>Tequila</strong>
                              </td>
                            </tr>
                            {liquorList[4].list.map((liquorTequila, index) => (
                              <tr key={index}>
                                <td>{liquorTequila.name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <p
                        className="item-intro text-muted"
                        style={{
                          marginBottom: "10px;",
                        }}
                      />
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                <strong>Scotch</strong>
                              </td>
                            </tr>
                            {liquorList[5].list.map((liquorScotch, index) => (
                              <tr key={index}>
                                <td>{liquorScotch.name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <p
                        className="item-intro text-muted"
                        style={{
                          marginBottom: "10px;",
                        }}
                      />
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                <strong>Other</strong>
                              </td>
                            </tr>
                            {liquorList[6].list.map((liquorOther, index) => (
                              <tr key={index}>
                                <td>{liquorOther.name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <p
                        className="item-intro text-muted"
                        style={{
                          marginBottom: "10px;",
                        }}
                      />
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                <strong>MixedDrink</strong>
                              </td>
                            </tr>
                            {liquorList[7].list.map((liquorDrinks, index) => (
                              <tr key={index}>
                                <td>{liquorDrinks.name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-dismiss="modal"
                        onClick={() => {
                          document
                            .getElementById("page-top")
                            .classList.remove("modal-open");
                          document.getElementById(
                            "page-top"
                          ).style.paddingRight = "0px";
                          document
                            .getElementById("menuLiquor")
                            .classList.remove("in");
                          setTimeout(function () {
                            document.getElementById(
                              "menuLiquor"
                            ).style.display = "none";
                          }, 400);
                        }}
                      >
                        <i className="fa fa-times"> Close</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Wine Menu */}
        <div
          className="portfolio-modal modal fade"
          id="menuWine"
          role="dialog"
          aria-hidden="true"
          style={{ background: "white" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div
                className="close-modal"
                data-dismiss="modal"
                onClick={() => {
                  document
                    .getElementById("page-top")
                    .classList.remove("modal-open");
                  document.getElementById("menuWine").classList.remove("in");
                  setTimeout(function () {
                    document.getElementById("menuWine").style.display = "none";
                  }, 400);
                }}
              >
                <div className="lr">
                  <div className="rl" />
                </div>
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-lg-8 col-lg-offset-2">
                    <div className="modal-body">
                      <h2>Wines</h2>
                      <p
                        className="item-intro text-muted"
                        style={{
                          marginBottom: "10px;",
                        }}
                      >
                        Red
                      </p>
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                <strong>Wine</strong>
                              </td>
                              <td>
                                {" "}
                                <strong>Type</strong>
                              </td>
                              <td>
                                {" "}
                                <strong>Location</strong>
                              </td>
                              <td>
                                {" "}
                                <strong>Description</strong>
                              </td>
                            </tr>
                            {wineList[0].list.map((wineRed, index) => (
                              <tr key={index}>
                                <td>{wineRed.name}</td>
                                <td>{wineRed.type}</td>
                                <td>{wineRed.location}</td>
                                <td>{wineRed.description}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <p
                        className="item-intro text-muted"
                        style={{
                          marginBottom: "10px;",
                        }}
                      >
                        White
                      </p>
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <tbody>
                            <tr>
                              <td>
                                {" "}
                                <strong>Wine</strong>
                              </td>
                              <td>
                                {" "}
                                <strong>Type</strong>
                              </td>
                              <td>
                                {" "}
                                <strong>Location</strong>
                              </td>

                              <td>
                                {" "}
                                <strong>Description</strong>
                              </td>
                            </tr>
                            {wineList[1].list.map((wineWhite, index) => (
                              <tr key={index}>
                                <td>{wineWhite.name}</td>
                                <td>{wineWhite.type}</td>
                                <td>{wineWhite.location}</td>

                                <td>{wineWhite.description}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-dismiss="modal"
                        onClick={() => {
                          document
                            .getElementById("page-top")
                            .classList.remove("modal-open");
                          document
                            .getElementById("menuWine")
                            .classList.remove("in");
                          setTimeout(function () {
                            document.getElementById("menuWine").style.display =
                              "none";
                          }, 400);
                        }}
                      >
                        <i className="fa fa-times"> Close</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MenuModals;



// WEBPACK FOOTER //
// ./src/scenes/landingPage/components/MenuModals.js